import './App.scss';
import App from './App';

export default App;
